import React, { useState, useEffect, useRef } from 'react';
import instagram_icon from '../assets/instagram2.png';
import twitter1 from '../assets/twitter1.png';
import twitter2 from '../assets/twitter2.png';
import discord_icon from '../assets/discord2.png';
import question from '../assets/question.png';
import warning_sign from '../assets/warning_sign.png';
import cloudComputingIcon from '../assets/cloud-computing.png';

// Модальное окно для Profile Name
export const ProfileNameModal = ({ isOpen, onClose, currentNickname, onSave }) => {
  const [nickname, setNickname] = useState(currentNickname || '');

  useEffect(() => {
    setNickname(currentNickname || '');
  }, [currentNickname]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave(nickname);
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div 
        className="bg-[#191919] relative rounded-[4px] border border-white/10 shadow-lg"
        style={{ 
          width: '400px', 
          height: '200px',
          boxShadow: '0 12px 16px -2px rgba(0, 0, 0, 0.7), 0 6px 12px -2px rgba(0, 0, 0, 0.5)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute text-white hover:text-red-500 transition-colors"
          style={{ 
            fontSize: '24px', 
            lineHeight: '1',
            right: '8px',
            top: '4px'
          }}
        >
          ×
        </button>

        {/* Title - Centered */}
        <div
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            top: '18px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '24px',
            color: 'rgba(255, 255, 255, 0.7)',
            whiteSpace: 'nowrap'
          }}
        >
          Profile Name
        </div>

        {/* Input Container */}
        <div
          className="absolute border rounded-[4px]"
          style={{
            width: '290px',
            height: '50px',
            left: '55px',
            top: '60px',
            backgroundColor: 'transparent',
            borderColor: '#790E0E'
          }}
        >
          {/* @ Symbol Container */}
          <div
            className="absolute flex items-center justify-center rounded-l-[2px]"
            style={{
              width: '50px',
              height: '100%',
              left: '0',
              top: '0',
              backgroundColor: '#790E0E',
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: '24px',
              color: '#FFFFFF',
              padding: '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <span style={{ lineHeight: '1', display: 'inline-block', transform: 'translateY(-3px)' }}>@</span>
          </div>

          {/* Input Field */}
          <input
            type="text"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            className="absolute bg-[#242424] text-white border-none outline-none rounded-r-[2px]"
            style={{
              left: '50px',
              top: '0',
              width: 'calc(100% - 50px)',
              height: '100%',
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: '18px',
              color: 'rgba(255, 255, 255, 0.7)',
              paddingLeft: '21px',
              paddingRight: '8px'
            }}
            placeholder="Enter nickname"
          />
        </div>

        {/* Question Icon */}
        <img
          src={question}
          alt="Help"
          style={{ 
            position: 'absolute',
            width: '24px',
            height: '24px',
            left: '354px',
            top: '73px',
            cursor: 'pointer',
            opacity: 0.4
          }}
        />

        {/* Save Button */}
        <button
          onClick={handleSave}
          className="absolute bg-[#4E86D3] hover:opacity-80 transition-opacity rounded-[4px] flex items-center justify-center"
          style={{
            width: '90px',
            height: '30px',
            left: '255px',
            top: '142px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '14px',
            color: '#FFFFFF',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

// Модальное окно для Instagram
export const InstagramModal = ({ isOpen, onClose, currentInstagram, onSave }) => {
  const [instagram, setInstagram] = useState(currentInstagram || '');

  useEffect(() => {
    setInstagram(currentInstagram || '');
  }, [currentInstagram]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave(instagram);
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div 
        className="bg-[#191919] relative rounded-[4px] border border-white/10 shadow-lg"
        style={{ 
          width: '400px', 
          height: '200px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute text-white hover:text-red-500 transition-colors"
          style={{ 
            fontSize: '24px', 
            lineHeight: '1',
            right: '8px',
            top: '4px'
          }}
        >
          ×
        </button>

        {/* Title - Centered */}
        <div
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            top: '19px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '24px',
            color: 'rgba(255, 255, 255, 0.7)',
            whiteSpace: 'nowrap'
          }}
        >
          Instagram Account
        </div>

        {/* Input Container */}
        <div
          className="absolute border rounded-[4px]"
          style={{
            width: '290px',
            height: '50px',
            left: '55px',
            top: '60px',
            backgroundColor: 'transparent',
            borderColor: '#790E0E'
          }}
        >
          {/* Instagram Icon Container */}
          <div
            className="absolute flex items-center justify-center rounded-l-[2px]"
            style={{
              width: '50px',
              height: '100%',
              left: '0',
              top: '0',
              backgroundColor: '#790E0E'
            }}
          >
            <img 
              src={instagram_icon} 
              alt="Instagram" 
              style={{ 
                width: '18px', 
                height: '18px',
                opacity: 0.8
              }} 
            />
          </div>

          {/* Input Field */}
          <input
            type="text"
            value={instagram}
            onChange={(e) => setInstagram(e.target.value)}
            className="absolute bg-[#242424] text-white border-none outline-none rounded-r-[2px]"
            style={{
              left: '50px',
              top: '0',
              width: 'calc(100% - 50px)',
              height: '100%',
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: '18px',
              color: 'rgba(255, 255, 255, 0.7)',
              paddingLeft: '21px',
              paddingRight: '8px'
            }}
            placeholder="https://instagram.com/profile"
          />
        </div>

        {/* Info Text with Warning Icon */}
        <div
          className="absolute flex items-center gap-1"
          style={{
            left: '118px',
            top: '113px',
            whiteSpace: 'nowrap'
          }}
        >
          <img
            src={warning_sign}
            alt="Warning"
            style={{
              width: '16px',
              height: '16px',
              flexShrink: 0,
              opacity: 0.4
            }}
          />
          <div
            style={{
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: '12px',
              color: 'rgba(255, 255, 255, 0.4)',
              marginLeft: '0px'
            }}
          >
            Make sure it's your personal instagram <br></br>account
          </div>
        </div>

        {/* Question Icon */}
        <img
          src={question}
          alt="Help"
          style={{ 
            position: 'absolute',
            width: '24px',
            height: '24px',
            left: '354px',
            top: '72px',
            cursor: 'pointer',
            opacity: 0.4
          }}
        />

        {/* Save Button */}
        <button
          onClick={handleSave}
          className="absolute bg-[#4E86D3] hover:opacity-80 transition-opacity rounded-[4px] flex items-center justify-center"
          style={{
            width: '90px',
            height: '30px',
            left: '255px',
            top: '142px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '14px',
            color: '#FFFFFF',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

// Модальное окно для Twitter
export const TwitterModal = ({ isOpen, onClose, currentTwitter, onSave }) => {
  const [twitter, setTwitter] = useState(currentTwitter || '');

  useEffect(() => {
    setTwitter(currentTwitter || '');
  }, [currentTwitter]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave(twitter);
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div 
        className="bg-[#191919] relative rounded-[4px] border border-white/10 shadow-lg"
        style={{ 
          width: '400px', 
          height: '200px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute text-white hover:text-red-500 transition-colors"
          style={{ 
            fontSize: '24px', 
            lineHeight: '1',
            right: '8px',
            top: '4px'
          }}
        >
          ×
        </button>

        {/* Title - Centered */}
        <div
          className="flex items-center justify-center"
          style={{
            position: 'absolute',
            left: '127px',
            top: '19px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '24px',
            color: 'rgba(255, 255, 255, 0.7)',
            whiteSpace: 'nowrap',
            gap: '4px'
          }}
        >
          Account on
          <img
            src={twitter1}
            alt="Twitter"
            style={{
              width: '18px',
              height: '18px',
              opacity: 0.7
            }}
          />
        </div>

        {/* Input Container */}
        <div
          className="absolute border rounded-[4px]"
          style={{
            width: '290px',
            height: '50px',
            left: '55px',
            top: '60px',
            backgroundColor: 'transparent',
            borderColor: '#790E0E'
          }}
        >
          {/* Twitter Icon Container */}
          <div
            className="absolute flex items-center justify-center rounded-l-[2px]"
            style={{
              width: '50px',
              height: '100%',
              left: '0',
              top: '0',
              backgroundColor: '#790E0E'
            }}
          >
            <img 
              src={twitter2} 
              alt="Twitter" 
              style={{ 
                width: '18px', 
                height: '18px',
                opacity: 0.7
              }} 
            />
          </div>

          {/* Input Field */}
          <input
            type="text"
            value={twitter}
            onChange={(e) => setTwitter(e.target.value)}
            className="absolute bg-[#242424] text-white border-none outline-none rounded-r-[2px]"
            style={{
              left: '50px',
              top: '0',
              width: 'calc(100% - 50px)',
              height: '100%',
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: '18px',
              color: 'rgba(255, 255, 255, 0.7)',
              paddingLeft: '21px',
              paddingRight: '8px'
            }}
            placeholder="https://x.com/NASA"
          />
        </div>

        {/* Info Text with Warning Icon */}
        <div
          className="absolute flex items-center gap-1"
          style={{
            left: '116px',
            top: '112px',
            whiteSpace: 'nowrap'
          }}
        >
          <img
            src={warning_sign}
            alt="Warning"
            style={{
              width: '16px',
              height: '16px',
              flexShrink: 0,
              opacity: 0.4
            }}
          />
          <div
            style={{
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: '12px',
              color: 'rgba(255, 255, 255, 0.4)',
              marginLeft: '0px'
            }}
          >
            Make sure it's your personal X <br></br>account
          </div>
        </div>

        {/* Question Icon */}
        <img
          src={question}
          alt="Help"
          style={{ 
            position: 'absolute',
            width: '24px',
            height: '24px',
            left: '355px',
            top: '73px',
            cursor: 'pointer',
            opacity: 0.4
          }}
        />

        {/* Save Button */}
        <button
          onClick={handleSave}
          className="absolute bg-[#4E86D3] hover:opacity-80 transition-opacity rounded-[4px] flex items-center justify-center"
          style={{
            width: '90px',
            height: '30px',
            left: '255px',
            top: '142px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '14px',
            color: '#FFFFFF',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

// Модальное окно для Discord
export const DiscordModal = ({ isOpen, onClose, currentDiscord, onSave }) => {
  const [discord, setDiscord] = useState(currentDiscord || '');

  useEffect(() => {
    setDiscord(currentDiscord || '');
  }, [currentDiscord]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave(discord);
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div 
        className="bg-[#191919] relative rounded-[4px] border border-white/10 shadow-lg"
        style={{ 
          width: '400px', 
          height: '200px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute text-white hover:text-red-500 transition-colors"
          style={{ 
            fontSize: '24px', 
            lineHeight: '1',
            right: '8px',
            top: '4px'
          }}
        >
          ×
        </button>

        {/* Title - Centered */}
        <div
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            top: '19px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '24px',
            color: 'rgba(255, 255, 255, 0.7)',
            whiteSpace: 'nowrap'
          }}
        >
          Discord Channel
        </div>

        {/* Input Container */}
        <div
          className="absolute border rounded-[4px]"
          style={{
            width: '290px',
            height: '50px',
            left: '55px',
            top: '60px',
            backgroundColor: 'transparent',
            borderColor: '#790E0E'
          }}
        >
          {/* Discord Icon Container */}
          <div
            className="absolute flex items-center justify-center rounded-l-[2px]"
            style={{
              width: '50px',
              height: '100%',
              left: '0',
              top: '0',
              backgroundColor: '#790E0E'
            }}
          >
            <img 
              src={discord_icon} 
              alt="Discord" 
              style={{ 
                width: '18px', 
                height: '18px',
                opacity: 0.7
              }} 
            />
          </div>

          {/* Input Field */}
          <input
            type="text"
            value={discord}
            onChange={(e) => setDiscord(e.target.value)}
            className="absolute bg-[#242424] text-white border-none outline-none rounded-r-[2px]"
            style={{
              left: '50px',
              top: '0',
              width: 'calc(100% - 50px)',
              height: '100%',
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: '18px',
              color: 'rgba(255, 255, 255, 0.7)',
              paddingLeft: '21px',
              paddingRight: '8px'
            }}
            placeholder="https://discord.gg/sewingfactory"
          />
        </div>

        {/* Info Text with Warning Icon */}
        <div
          className="absolute flex items-center gap-1"
          style={{
            left: '135px',
            top: '113px',
            whiteSpace: 'nowrap'
          }}
        >
          <img
            src={warning_sign}
            alt="Warning"
            style={{
              width: '16px',
              height: '16px',
              flexShrink: 0,
              opacity: 0.4
            }}
          />
          <div
            style={{
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: '12px',
              color: 'rgba(255, 255, 255, 0.4)',
              marginLeft: '0px'
            }}
          >
            Make sure it's your discord channel
          </div>
        </div>

        {/* Question Icon */}
        <img
          src={question}
          alt="Help"
          style={{ 
            position: 'absolute',
            width: '24px',
            height: '24px',
            left: '355px',
            top: '73px',
            cursor: 'pointer',
            opacity: 0.4
          }}
        />

        {/* Save Button */}
        <button
          onClick={handleSave}
          className="absolute bg-[#4E86D3] hover:opacity-80 transition-opacity rounded-[4px] flex items-center justify-center"
          style={{
            width: '90px',
            height: '30px',
            left: '255px',
            top: '142px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '14px',
            color: '#FFFFFF',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

// Модальное окно для Bio
export const BioModal = ({ isOpen, onClose, currentBio, onSave }) => {
  const [bio, setBio] = useState(currentBio || '');
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    console.log('🔄 BioModal: currentBio изменился на:', currentBio);
    setBio(currentBio || '');
    setShowError(false); // Сбрасываем ошибку при открытии модального окна
  }, [currentBio, isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    const bioLength = bio.trim().length;
    
    if (bioLength < 60 || bioLength > 150) {
      setShowError(true);
      return;
    }

    console.log('💾 BioModal: Сохранение bio:', bio);
    onSave(bio);
    setShowError(false);
    onClose();
  };

  const handleBioChange = (e) => {
    setBio(e.target.value);
    if (showError) {
      setShowError(false); // Скрываем ошибку при изменении текста
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div 
        className="bg-[#191919] relative rounded-[4px] border border-white/10 shadow-lg"
        style={{ 
          width: '400px', 
          height: '270px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute text-white hover:text-red-500 transition-colors"
          style={{ 
            fontSize: '18px', 
            lineHeight: '1',
            right: '8px',
            top: '6px',
            opacity: 0.6
          }}
        >
          ×
        </button>

        {/* Title - Centered */}
        <div
          style={{
            position: 'absolute',
            left: '183px',
            top: '10px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '24px',
            color: 'rgba(255, 255, 255, 0.8)',
            whiteSpace: 'nowrap'
          }}
        >
          Bio
        </div>

        {/* Textarea Container */}
        <div
          className="absolute border rounded-[6px]"
          style={{
            width: '260px',
            height: '150px',
            left: '70px',
            top: '54px',
            backgroundColor: '#242424',
            borderColor: '#A90909'
          }}
        >
          {/* Textarea */}
          <textarea
            value={bio}
            onChange={handleBioChange}
            className="absolute bg-transparent text-white border-none outline-none resize-none rounded-[2px]"
            style={{
              left: '12px',
              top: '14px',
              width: 'calc(100% - 24px)',
              height: 'calc(100% - 28px)',
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: '14px',
              color: 'rgba(255, 255, 255, 0.8)',
              lineHeight: '1.4'
            }}
            placeholder="There is a day when i thought..."
            maxLength={150}
          />
        </div>

        {/* Info Text with Warning Icon - показывается только при ошибке */}
        {showError && (
          <div
            className="absolute flex items-center gap-1"
            style={{
              left: '113px',
              top: '206px',
              whiteSpace: 'nowrap'
            }}
          >
            <img
              src={warning_sign}
              alt="Warning"
              style={{
                width: '16px',
                height: '16px',
                flexShrink: 0,
                opacity: 0.4
              }}
            />
            <div
              style={{
                fontFamily: 'Keania One',
                fontWeight: 400,
                fontSize: '10px',
                color: 'rgba(255, 255, 255, 0.4)',
                marginLeft: '9px'
              }}
            >
              Bio should contain from 60 to 150 characters
            </div>
          </div>
        )}

        {/* Save Button */}
        <button
          onClick={handleSave}
          className="absolute bg-[#4E86D3] hover:opacity-80 transition-opacity rounded-[4px] flex items-center justify-center"
          style={{
            width: '74px',
            height: '24px',
            left: '256px',
            top: '224px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '10px',
            color: '#FFFFFF',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

// Модальное окно для Background Image
export const BackgroundImageModal = ({ isOpen, onClose, currentImage, onSave }) => {
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (currentImage) {
      setImagePreview(currentImage);
    } else {
      setImagePreview(null);
    }
    setSelectedFile(null);
  }, [currentImage, isOpen]);

  if (!isOpen) return null;

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Проверка формата
      if (!file.type.match(/^image\/(jpeg|jpg|png)$/)) {
        alert('Only JPEG or PNG format is allowed');
        return;
      }
      // Проверка размера (10 MB для background)
      if (file.size > 10 * 1024 * 1024) {
        alert('The maximum size of image is 10 MB');
        return;
      }
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleSave = () => {
    if (selectedFile) {
      onSave(selectedFile);
    } else if (imagePreview) {
      onSave(imagePreview);
    }
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div 
        className="bg-[#191919] relative rounded-[4px] border border-white/10 shadow-lg"
        style={{ 
          width: '440px', 
          height: '295px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute text-white hover:text-red-500 transition-colors"
          style={{ 
            fontSize: '24px', 
            lineHeight: '1',
            right: '8px',
            top: '4px',
            opacity: 0.6
          }}
        >
          ×
        </button>

        {/* Title - Centered */}
        <div
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            top: '19px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '24px',
            color: 'rgba(255, 255, 255, 0.7)',
            whiteSpace: 'nowrap',
            opacity: 0.65
          }}
        >
          Background Image
        </div>

        {/* Upload Area */}
        <div
          className="absolute border rounded-[6px] flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity"
          style={{
            width: '290px',
            height: '75px',
            left: '70px',
            top: '70px',
            backgroundColor: '#242424',
            borderColor: '#A90909'
          }}
          onClick={handleUploadClick}
        >
          {imagePreview ? (
            <img 
              src={imagePreview} 
              alt="Preview" 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '6px'
              }}
            />
          ) : (
            <button
              className="border hover:opacity-90 transition-opacity rounded-[4px] flex items-center justify-center gap-2"
              style={{
                padding: '10px 20px',
                fontFamily: 'Keania One',
                fontWeight: 400,
                fontSize: '12px',
                backgroundColor: 'rgba(78, 134, 211, 0.4)',
                borderColor: '#4E86D3',
                color: 'rgba(255, 255, 255, 0.7)',
                cursor: 'pointer',
                width: '90px',
                height: '24px'
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleUploadClick();
              }}
            >
              <img 
                src={cloudComputingIcon} 
                alt="Upload" 
                style={{ 
                  width: '14px', 
                  height: '14px' 
                }} 
              />
              Upload
            </button>
          )}
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/jpg,image/png"
            onChange={handleFileSelect}
            style={{ display: 'none' }}
          />
        </div>

        {/* Requirements */}
        <div
          style={{
            position: 'absolute',
            left: '90px',
            top: '165px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '12px',
            color: 'rgba(255, 255, 255, 0.6)',
            lineHeight: '1.6'
          }}
        >
          <div>• JPEG or PNG format only</div>
          <div>• The maximum size of image is 10 MB</div>
          <div>• The resalution of image should be 1680x600</div>
        </div>

        {/* Save Button */}
        <button
          onClick={handleSave}
          className="absolute bg-[#4E86D3] hover:opacity-80 transition-opacity rounded-[4px] flex items-center justify-center"
          style={{
            width: '90px',
            height: '30px',
            left: '260px',
            top: '237px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '12px',
            color: '#FFFFFF',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

// Модальное окно для Profile Image
export const ProfileImageModal = ({ isOpen, onClose, currentImage, onSave }) => {
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (currentImage) {
      setImagePreview(currentImage);
    } else {
      setImagePreview(null);
    }
    setSelectedFile(null);
  }, [currentImage, isOpen]);

  if (!isOpen) return null;

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Проверка формата
      if (!file.type.match(/^image\/(jpeg|jpg|png)$/)) {
        alert('Only JPEG or PNG format is allowed');
        return;
      }
      // Проверка размера (5 MB для profile)
      if (file.size > 5 * 1024 * 1024) {
        alert('The maximum size of image is 5 MB');
        return;
      }
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleSave = () => {
    if (selectedFile) {
      onSave(selectedFile);
    } else if (imagePreview) {
      onSave(imagePreview);
    }
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div 
        className="bg-[#191919] relative rounded-[4px] border border-white/10 shadow-lg"
        style={{ 
          width: '400px', 
          height: '295px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute text-white hover:text-red-500 transition-colors"
          style={{ 
            fontSize: '24px', 
            lineHeight: '1',
            right: '8px',
            top: '4px'
          }}
        >
          ×
        </button>

        {/* Title - Centered */}
        <div
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            top: '19px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '24px',
            color: 'rgba(255, 255, 255, 0.6)',
            whiteSpace: 'nowrap'
          }}
        >
          Profile Image
        </div>

        {/* Profile Image Circle */}
        <div
          className="absolute rounded-full border-2 flex items-center justify-center overflow-hidden"
          style={{
            width: '100px',
            height: '100px',
            left: '50px',
            top: '60px',
            borderColor: '#790E0E',
            backgroundColor: imagePreview ? 'transparent' : '#242424'
          }}
        >
          {imagePreview ? (
            <img 
              src={imagePreview} 
              alt="Profile Preview" 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          ) : (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '4px',
                width: '60px',
                height: '60px'
              }}
            >
              
            </div>
          )}
        </div>

        {/* Upload Button */}
        <button
          onClick={handleUploadClick}
          className="absolute hover:opacity-90 transition-opacity rounded-[4px] flex items-center justify-center gap-2 border"
          style={{
            width: '90px',
            height: '30px',
            left: '180px',
            top: '90px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '12px',
            backgroundColor: 'rgba(78, 134, 211, 0.4)',
            borderColor: '#4E86D3',
            color: 'rgba(255, 255, 255, 0.7)',
            cursor: 'pointer'
          }}
        >
          <img 
            src={cloudComputingIcon} 
            alt="Upload" 
            style={{ 
              width: '14px', 
              height: '14px' 
            }} 
          />
          Upload
        </button>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/jpeg,image/jpg,image/png"
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />

        {/* Requirements */}
        <div
          style={{
            position: 'absolute',
            left: '50px',
            top: '175px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '12px',
            color: 'rgba(255, 255, 255, 0.6)',
            lineHeight: '1.6'
          }}
        >
          <div>• JPEG or PNG format only</div>
          <div>• The maximum size of image is 5 MB</div>
          <div>• The resalution of image should be 512x512 [min]</div>
        </div>

        {/* Save Button */}
        <button
          onClick={handleSave}
          className="absolute bg-[#4E86D3] hover:opacity-80 transition-opacity rounded-[4px] flex items-center justify-center"
          style={{
            width: '90px',
            height: '30px',
            left: '270px',
            top: '237px',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: '12px',
            color: '#FFFFFF',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};